// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5287":"courseware__Detail__index","6131":"ai__ConversationLayout__index","8244":"ai__PptChat__index"}[chunkId] || chunkId) + "." + {"1700":"e0f70b58","5287":"987aee0f","6131":"987aee0f","8244":"987aee0f"}[chunkId] + ".chunk.css";
};